import apiClient from "api-client";

import getWrappedUseQuery from "../../helpers/getWrappedUseQuery";
import KEYS from "../keys";

export const useGetTemplatesQuery = getWrappedUseQuery(KEYS.GET_TEMPLATES, apiClient.Template.get);
